import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { IUserTeamMembership } from '@nimbus-portal/features/personal/model/i-user-team-membership.model';
import { IMap } from '@nimbus-library/features/shared/models/interfaces';
import { MemberInfo } from '@nimbus-global/features/shared/models/api/member-info.model';

@Injectable({ providedIn: 'root' })
export class AcUserApiClient {
  public constructor(private readonly httpService: BaseHttpService) {}

  public getMembershipsByUserId(userId: string): Observable<IUserTeamMembership[]> {
    return this.httpService.get(`facade/v1/portal/users/${userId}/memberships`);
  }

  public getTeamsMembers(tenantId: string, userId: string, teamIds: string[]): Observable<IMap<Array<MemberInfo>>> {
    const query = teamIds.map((teamId) => `teamIds=${teamId}`).join('&');
    return this.httpService.get(`facade/v1/portal/tenants/${tenantId}/users/${userId}/teams/members?${query}`);
  }
}
